module.exports = __webpack_public_path__ + "components/blogs-header/static/header--medium-0f02f982c8be1b76f3d4488e6dda9117.jpg";